import { Box, GridItem, Heading, Text, HStack, IconButton, Button} from "@chakra-ui/react"
import { FaCog, FaPlay, FaStop } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { CompanyProcessStatus } from "@companyProcess/types/companyProcess";
import type { CompanyProcessPlayItemProps } from "./types";
import { IoTrashOutline } from "react-icons/io5";

const CompanyProcessPlayItem = ({item, onPressEdit, onPressDelete, onChangeProcessStatus, setSelectedProceso}: CompanyProcessPlayItemProps) => {
    return (
        <GridItem w="100%" h="230px"  bg="white" px={2} py={4} borderRadius={8} shadow="sm">
            <Heading as="h6" fontSize="xl" fontWeight={600} noOfLines={1}>{item.nombre}</Heading>
            <Box mt={4}>
                <HStack mb={1} spacing={1} alignItems="center">
                    <FaCog
                        size="1.3rem"
                        color={Number(item.activo) === CompanyProcessStatus.PLAYING ? 'green' : 'gray'}
                    />
                    <Text
                        fontSize="md"
                        fontWeight={500}
                    >
                        {Number(item.activo) === CompanyProcessStatus.PLAYING ? 'Ejecutandose' : 'Detenido'}
                    </Text>
                </HStack>
                <Text fontWeight={500} pl={6}>Trans 1/2</Text>
                <HStack pl={4} mt={2}>
                    <IconButton
                        aria-label="Play process"
                        icon={<FaPlay/>}
                        isRound
                        isDisabled = {Number(item.activo) === CompanyProcessStatus.PLAYING}
                        bg={Number(item.activo) === CompanyProcessStatus.STOPPED ? 'green.400' : 'gray.200'}
                        onClick={() => onChangeProcessStatus(item.publicId, 'play')}
                    />
                    <IconButton
                        aria-label="Stop process"
                        icon={<FaStop/>}
                        isRound
                        isDisabled = {Number(item.activo) === CompanyProcessStatus.STOPPED}
                        bg={Number(item.activo) === CompanyProcessStatus.PLAYING ? 'red.400' : 'gray.200'}
                        onClick={() => onChangeProcessStatus(item.publicId, 'stop')}/>
                </HStack>
            </Box>
            <HStack mt={6} justifyContent="space-between">
                <HStack>
                    <Button onClick={() => setSelectedProceso(item)}>Logs</Button>
                </HStack>
                <HStack>
                    <IconButton
                        aria-label="Delete"
                        variant="ghost"
                        colorScheme="red"
                        icon={<IoTrashOutline size={18}/>}
                        onClick={() => onPressDelete(item)}
                    />
                    <IconButton
                        aria-label="Edit"
                        variant="ghost"
                        colorScheme="teal"
                        icon={<CiEdit size={20}/>}
                        onClick={() => onPressEdit(item)}
                    />
                </HStack>
            </HStack>
        </GridItem>
    )
}
export default CompanyProcessPlayItem
